import { TextField } from "../components/TextField";
import { Button } from "../components/Button";
import { Select } from "../components/Select";
import { Form, redirect } from "react-router-dom";
import { addBuddy } from "../services/api";
import { useEffect, useState } from "react";
import mixpanel from "../services/mixpanel";
import { getUserId } from "../services/helpers";

export async function AddBuddyAction ({request}){
	try{

	const data = await request.formData();
	const formToJSON = {};
  for (const [key, value] of [...data.entries()]) {
    formToJSON[key] = value;
  }
  	const response = await addBuddy(formToJSON);


if (!response.ok) {
	throw new Error('Network response was not ok');
}

const result = await response.json();
	return redirect("/dashboard/buddies");
} catch(e){
	console.log("error", e);
	if (e.response) {
		const errorBody = await e.response.json();
		console.log("error body", errorBody);
	}
}
}

export function AddBuddy(){
	const [isMember, setIsMember] = useState(false);

	useEffect(()=>{
		mixpanel.identify(getUserId());
	},[])
	return (
	<main id="AddMember">
		<h1>Add A Buddy</h1>

		<Form method="post"  encType="multipart/form-data">
			{/* Member bio card  */}
			<div className="card">
				<p className="label">Buddy Bio</p>
				<div className="row" id="member-bio-grid">

					{/* <TextField
					name="profile_image"
					label="Buddy Profile Image"
					type="file"
					/> */}
					<div className="col">
						<TextField
						label="Full Name"
						name="name"
						/>
					</div>




					<TextField
					label="Role"
					subLabel="(Title of buddy)"
					name="role"
					/>
					<TextField
					label="Email"
					name="email"
					/>
					<TextField
					label="Temporary Password"
					name="password"
					type="password"
					/><TextField
					label="Phone Number"
					name="phone_number"
					/>
					<Select
					label="Permissions"
					name="permissions"
					options={["basic","admin","dev"]}
					/>


				</div>

			</div>

			{/* Vehicle Details  */}
			<div className="card">
				<p className="label">Assign Members</p>
				<div className="tabs">
					<button type="button" onClick={() => setIsMember(false)} className={!isMember ? "active" : ""}>
						All Members

					</button>
					<button type="button" onClick={() => setIsMember(true)} className={isMember ? "active" : ""}>
						Assigned Members
					</button>
					</div>
				<div className="tab-content">
					{isMember ? (
						<div>
							{/* Content for Assigned Members */}
							<p>Assigned Members content goes here...</p>
						</div>
					) : (
						<div>
							{/* Content for All Members */}
							<p>All Members content goes here...</p>
						</div>
					)}
				</div>
			</div>

			<Button
			label="Add Buddy"
			color="blue"
			type="submit"
			id="addMemberButton"
			/>
		</Form>
	</main>)
}